import { render, staticRenderFns } from "./EducationalLevel.vue?vue&type=template&id=4b115e3e&lang=true"
import script from "./EducationalLevel.vue?vue&type=script&lang=js"
export * from "./EducationalLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports